import { getVisibleFilters } from '../../../utils/filter'

import { ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS } from './EntityTabRequests.constants'

export function hasEntityTabRequestsItems(requests) {
  return requests?.items?.length > 0
}

export function hasEntityTabRequestsVisibleFilters(availableFilters) {
  return getVisibleFilters(availableFilters).length > 0
}

export function isEntityTabRequestsToolbarCollapsed({
  hasFilterChanged,
  hasRequests,
  hasVisibleFilters,
  isLoading,
  shouldShowCreateButton,
}) {
  return (
    !isLoading &&
    ((!hasRequests && !hasFilterChanged) ||
      (!hasVisibleFilters && !shouldShowCreateButton))
  )
}

export function getEntityTabRequestsScopeFilter({ scopeFilterKey, scopeId }) {
  return {
    [scopeFilterKey]: ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
  }
}

export function getEntityTabRequestsSubTabCount(counter) {
  return counter?.total ?? null
}
